import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import InputSelectEstados from "./InputSelectEstados";
import { useApiFetch } from "../utils/apiFetch";

function RegistrarTecnicos() {

    const { setModuloActual, setSubModuloActual, permisos, logout } = useGlobal();
    const apiFetch = useApiFetch();
    const [idTecnico, setIdTecnico] = useState("");
    const [idRol, setIdRol] = useState("");
    const [idEstado, setIdEstado] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [success, setSuccess] = useState(false);
    const [codigoTemp, setCodigoTemp] = useState("");

    const tienePermisoRegistrar = permisos.includes(5); // id_permiso = 5; "Registrar técnicos"

    const validarIdTecnico = (id) => /^\d{7}$/.test(id);

    useEffect(() => {
        if (mensaje && !success) {   // Solo limpiar si no es éxito
            const timer = setTimeout(() => {
                setMensaje(""); // limpia el mensaje
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [mensaje, success]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje("");

        if (!validarIdTecnico(idTecnico)) {
            return setMensaje("El ID técnico debe contener exactamente 7 dígitos.");
        }
        if (!idRol || !idEstado) {
            return setMensaje("Debe seleccionar rol y estado.");
        }

        try {
            const data = await apiFetch("registrar_tecnicos.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_tecnico: idTecnico, id_rol: idRol, id_estado: idEstado })
            }, logout);

            if (data.status === "ok") {
                setMensaje(data.message);
                setCodigoTemp(data.codigo_temp);
                setSuccess(true);
            } else if (data.status === "warning") {
                setMensaje("\u26A0 " + data.message);
                setCodigoTemp(data.codigo_temp);
                setSuccess(true);
            } else {
                setMensaje("\u274C " + data.message);
            }
        } catch {
            setMensaje("Error de conexión con el servidor.");
        }
    };

    if (!tienePermisoRegistrar) {
        return <p>Acceso denegado. No tiene permiso para registrar técnicos.</p>;
    }

    if (success) {
        return (
            <div className="sesion-form">
                <p className="success">{mensaje}</p>
                <p><strong>Código de registro:</strong> {codigoTemp}</p>
                <button onClick={() => {
                    setModuloActual("Control");
                    setSubModuloActual(null);
                }}>
                    Continuar
                </button>
            </div>
        );
    }

    return (
        <div className="sesion-form">

            {mensaje && (
                <div className={success ? "success" : "error"}>
                    {mensaje}
                </div>
            )}

            <form onSubmit={handleSubmit}>

                <InputGenerico
                    value={idTecnico}
                    setValue={setIdTecnico}
                    label="Número de empleado"
                    maxLength={7}
                    allowedChars="0-9"
                    placeholder="7120000"
                    title="Debe contener exactamente 7 dígitos numéricos"
                />

                <InputSelectGenerico
                    idSeleccionado={idRol}
                    setIdSeleccionado={setIdRol}
                    label="Rol a desempeñar"
                    apiUrl={`consultar_roles.php`}
                    valueField="id_rol"
                    displayField="rol"
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un rol"
                />

                <InputSelectEstados
                    idEstado={idEstado}
                    setIdEstado={setIdEstado}
                    estadoActualText=""
                    idEntidad={2}
                    label="Estado inicial del técnico"
                />

                <div className="form-buttons">
                    <button type="submit">Registrar</button>
                </div>
            </form>
        </div>
    );
}

export default RegistrarTecnicos;